import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  titleSection: {
    padding: '24px 32px 25px 32px',
    backgroundColor: '#064e75',
  },
  contentSection: {
    padding: '21px 47px 21px 49px',
    borderBottom: '1px solid #e5e5e5',
  },
  footerSection: {
    justifyContent: 'space-between',
    padding: '15px 28px 22px 61px',
  },

  titleSectionRightSide: {
    '& svg': {
      color: '#ffffff',
      cursor: 'pointer',
    },
    '@media (max-width:600px)': {
      position: 'absolute',
      right: '20px',
      top: '15px',
    },
  },

  dialogWrapper: {
    '& .MuiDialog-paper': {
      maxWidth: 785,
    },
  },
  editForm: {
    '& label': {
      zIndex: 0,
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'solid 1px #e5e5e5',
    },
    '& .MuiSelect-icon': {
      marginRight: '0px !important',
    },
    '& .MuiListItemText-root': {
      margin: '0px !important',
    },
  },

  titleSectionWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  titleSectionLeftSide: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width:600px)': {
      flexDirection: 'column',
    },
  },
  sectionTitle: {
    color: '#ffffff',
    fontSize: 22,
    fontWeight: 'bold',
    flex: '0 1 auto',
  },
  sectionTitleGroup: {
    flex: '0 0 auto',
    marginRight: 20,
  },
  groupCount: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    border: 'solid 1px #ffffff',
    marginLeft: 22,
    color: '#00e0ff',
    fontSize: 14,
    padding: '5px 9px 5px 15px',
    cursor: 'pointer',
    '& span': {
      marginLeft: 9,
    },
  },

  contentSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: 322,
  },
  firstFormRow: {
    marginBottom: '0px !important',
  },
  formRow: {
    display: 'flex',
    flex: '0 0 auto',
    width: '100%',
    marginBottom: 23,
  },
  formRowIcon: {
    width: 81,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    textAlign: 'center',
    position: 'relative',
  },
  formRowIconWrapper: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
  },
  avatarIcon: {
    width: '100%',
    height: '100%',
  },
  formRowIconChoose: {
    position: 'relative',
    width: 52,
    height: 52,
    overflow: 'hidden',
    borderRadius: '50%',
    cursor: 'pointer',
    '&:hover': {
      '& $formRowIconChooseBg': {
        zIndex: 1,
      },
    },
    '& svg': {
      position: 'absolute',
      fontSize: 14,
      color: '#fff',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
    },
    '& img': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
      backgroundColor: '#ffffff',
    },
  },
  formRowIconChooseBg: {
    backgroundColor: 'rgb(64 64 64 / 70%)',
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  formRowIconText: {
    color: '#ffffff',
    fontSize: 7,
    padding: '2px 0px',
    backgroundColor: 'rgb(64 64 64 / 50%)',
    marginTop: 4,
    width: '100%',
  },

  formRowInputs: {
    display: 'flex',
    width: '100%',
    marginLeft: 10,
  },

  customFieldStyle: {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    marginBottom: 23,
    marginLeft: 77,
    '& > div:nth-child(odd)': {
      width: '100%',
      paddingRight: 15,
      marginBottom: 10,
    },
    '& > div:nth-child(even)': {
      width: '100%',
      marginLeft: 20,
      paddingRight: 20,
      marginBottom: 10,
    },
  },
  formRowLeftItem: {
    width: '50%',
    marginRight: 35,
  },
  formRowItemOne: {
    width: '50%',
  },
  formRowItemTwo: {
    width: '100%',
  },
  showMore: {
    textTransform: 'uppercase',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#404040',
    cursor: 'pointer',
  },
  actionBtn: {
    marginLeft: 16,
    padding: '11px 33px',
  },
  reactPhoneWrapper: {
    '& .flag-dropdown': {
      marginLeft: '5px',
    },
  },
  hide: {
    display: 'none',
  },
  groupRow: {
    display: 'flex',
    width: '100%',
    marginTop: 50,
    marginBottom: 42,
    color: '#0073b1',
  },
  groupRowFirst: {
    marginTop: '25px !important',
  },
  groupRowIcon: {
    width: 41,
    textAlign: 'center',
    marginRight: 14,
    marginLeft: 33,
  },
  groupRowTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    alignItems: 'center',
    display: 'flex',
    borderBottom: 'solid 1px #e5e5e5',
    width: '100%',
    paddingBottom: 10,
    justifyContent: 'space-between',
  },
  jobSuggestionWrapper: {
    position: 'relative',
    '& .MuiFormControl-marginNormal': {
      marginTop: '0px !important',
    },
  },
  jobSuggestion: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 9,
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderLeft: '1px solid',
    borderRight: '1px solid',
    overflowX: 'auto',
    maxHeight: 132,
    '& div': {
      padding: '5px 5px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, .2)',
      },
    },
  },
  datePicker: {
    '& label.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '& input.Mui-disabled': {
      color: '#21213e',
    },
  },

  formTranslateRow: {
    display: 'flex',
    width: '100%',
    minHeight: 0,
    transition: 'min-height 0.3s ease-out',
    overflow: 'hidden',
  },
  formTranslateRowActive: {
    minHeight: 50,
  },
  formTranslateSecondRowActive: {
    minHeight: 75,
  },
  formTranslateWrapper: {
    width: '100%',
    display: 'flex',
    backgroundColor: 'rgb(168 168 168 / 20%)',
    alignItems: 'flex-start',
    padding: '12px 18px 12px 23px',
    margin: '0px 5px 10px 16px',
    color: '#404040',
    fontSize: 14,
  },
  formTranslateBtn: {
    color: '#0073b1',
    cursor: 'pointer',
    marginLeft: 6,
    '&.disabled': {
      color: '#c1c1c1',
      pointerEvents: 'none',
    },
  },
  formCloseTranslate: {
    marginLeft: 'auto',
    fontSize: 16,
    cursor: 'pointer',
  },
  newCustomDialogStyle: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 80px',
    '& span': {
      color: '#0073b1',
      borderBottom: '1px solid #0073b1',
      fontSize: 'large',
      fontWeight: '600',
      marginLeft: '1rem',
    },
  },
  customLabelWrapper: {
    display: 'flex',
  },
  customLabelCloseIcon: {
    color: '#707070',
    cursor: 'pointer',
    top: '17px',
    position: 'relative',
  },
  subscriberDetailsStatus: {
    '& > div': {
      marginLeft: 15,
      fontWeight: 'normal',
      padding: '17px 27px',
    },
  },
  contactFields: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(1, minmax(0, 1fr)) !important',
    marginLeft: '0.75rem !important',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr)) !important',
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: '#E3342F !important',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E3342F !important',
    },
    '& p': {
      margin: '0',
      lineHeight: '1.4',
      marginTop: '0.5rem',
      color: '#E3342F !important',
    },
  },
}))
